module.exports = (__parcel__import__("1FqUu")).then(() => parcelRequire('2geSQ'));